import React from 'react'
import './Result.css'

const Result = (props) => {
  return (
    <div className="search-result">
      <h2><a href={props.url}>{props.headline}</a></h2>
      <p className="search-result-url">{props.url}</p>
      <p className="search-result-description">{props.descr}</p>
    </div>
  )
}

export default Result


// WEBPACK FOOTER //
// ./src/components/Result.js